import axios from "axios";
import { useURL } from "../data/Config";
import { ICategory } from "../types";

interface UpdateCategoryResponse {
  success: string;
  category: ICategory;
}

interface DeleteCategoryResponse {
  success: string;
}

export const getAllCategoriesByAdmin = async (
  searchQuery?: string
): Promise<ICategory[]> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get<ICategory[]>(
    `${useURL}/categories/admin/get-all-categories`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        searchQuery,
      },
    }
  );

  return response.data;
};

export const updateCategoryByAdmin = async (
  id: string,
  data: { name: string; isFeatured: boolean }
): Promise<UpdateCategoryResponse> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.patch<UpdateCategoryResponse>(
    `${useURL}/categories/admin/update-category/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const createCategoryByAdmin = async (data: {
  name: string;
  isFeatured: boolean;
}) => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.post(
    `${useURL}/categories/admin/create-category`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const deleteCategoryByAdmin = async (
  id: string
): Promise<DeleteCategoryResponse> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.delete<DeleteCategoryResponse>(
    `${useURL}/categories/admin/delete-category/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
